import { ClaimSummaryField, ReceiptUploadOption, UseMyMoneyOption, UseMyMoneyStep } from '@/modules/UseMyMoney/UseMyMoney.types';
import { storeCreator } from '@/utils/store/store.utils';

interface UseMyMoneyState {
  employeeId?: string;
  setEmployeeId: (employeeId?: string) => void;
  useMyMoneyStep?: UseMyMoneyStep;
  setUseMyMoneyStep: (useMyMoneyStep: UseMyMoneyStep) => void;
  receiptUploadOption?: ReceiptUploadOption;
  setReceiptUploadOption: (receiptUploadOption?: ReceiptUploadOption) => void;
  useMyMoneyOption?: UseMyMoneyOption;
  setUseMyMoneyOption: (useMyMoneyOption?: UseMyMoneyOption) => void;
  activeField?: ClaimSummaryField;
  setActiveField: (activeField?: ClaimSummaryField) => void;
  resetStore: () => void;
}

const DEFAULT_OPTIONS = {
  useMyMoneyStep: UseMyMoneyStep.SELECT_OPTION,
  useMyMoneyOption: UseMyMoneyOption.REIMBURSE_MYSELF,
  employeeId: undefined,
  receiptUploadOption: undefined,
  activeField: undefined,
};

const useMyMoneyStore = storeCreator<UseMyMoneyState>((set) => ({
  ...DEFAULT_OPTIONS,

  setUseMyMoneyStep: (useMyMoneyStep: UseMyMoneyStep) =>
    set((state) => ({
      ...state,
      useMyMoneyStep,
    })),

  setEmployeeId: (employeeId?: string) =>
    set((state) => ({
      ...state,
      employeeId,
    })),

  setUseMyMoneyOption: (useMyMoneyOption?: UseMyMoneyOption) =>
    set((state) => ({
      ...state,
      useMyMoneyOption,
    })),

  setReceiptUploadOption: (receiptUploadOption?: ReceiptUploadOption) =>
    set((state) => ({
      ...state,
      receiptUploadOption,
    })),

  setActiveField: (activeField?: ClaimSummaryField) =>
    set((state) => ({
      ...state,
      activeField,
    })),

  resetStore: () =>
    set((state) => ({
      ...state,
      ...DEFAULT_OPTIONS,
    })),
}));

export default useMyMoneyStore;
